

import React from 'react';
import propTypes from 'prop-types';
import {
  Link
} from "react-router-dom";


export default function Navbar(props) {
  return(
    <nav className={props.darkMode ? "navbar navbar-expand-lg navbar-dark bg-dark" : "navbar navbar-expand-lg navbar-light bg-light"}>
    <div className="container-fluid">
      <Link className="navbar-brand" to="/">{props.title}</Link>
      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
          <li className="nav-item">
            <Link className="nav-link active" aria-current="page" to="/">Home</Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/about">{props.aboutText}</Link>
          </li>
          
        </ul>

        {/* <form className="d-flex">
          <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search"/>
          <button className="btn btn-outline-success" type="submit">Search</button>
        </form> */}

        <div className={`form-check form-switch mx-5 ${props.darkMode?'text-light':'text-dark'}`}>
          <input className="form-check-input" onClick={props.toggleMode} type="checkbox" role="switch" id="flexSwitchCheckDefault" />
          <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
            {/* {props.darkMode?"hehe":"hoho"} */}
            {/* {props.darkMode?<span class="material-icons">light_mode</span>:<span class="material-icons">dark_mode</span>} */}
            <span className="material-icons">{props.darkMode?"light_mode":"dark_mode"}</span>
          </label>
        </div>

      </div>
    </div>
  </nav>
  );
}

Navbar.propTypes={
  title: propTypes.string.isRequired,
  aboutText: propTypes.string
};

Navbar.defaultProps={
  title: "set title here",
  aboutText: 'About text here'
};




